var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDarkSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31,
    viewBox: "0 0 32 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9363 30.9988C12.5265 30.9988 9.37337 29.9332 6.78851 28.1091L8.78674 26.4114C10.84 27.7298 13.2965 28.4884 15.9363 28.4884C21.2894 28.4884 25.8908 25.3458 27.944 20.8487L30.2906 21.824C27.8524 27.2422 22.3343 30.9988 15.9363 30.9988Z",
    fill: "#2187FB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.68125 2.16702C3.07983 4.87612 0 9.82474 0 15.4777C0 19.5955 1.63158 23.3341 4.28977 26.1154L6.21466 24.4719C3.94145 22.1421 2.52986 18.9634 2.52986 15.4777C2.52986 10.6555 5.20638 6.4474 9.16617 4.20788L7.68125 2.16702Z",
    fill: "#2187FB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4401 15.496C31.4401 16.7061 31.2934 17.88 31.0368 18.9998L28.6536 18.0065C28.8185 17.1937 28.9102 16.3449 28.9102 15.478C28.9102 8.3079 23.0072 2.49237 15.7293 2.49237C14.4277 2.49237 13.1811 2.67298 12.0078 3.01613L10.4312 0.903032C12.0811 0.325092 13.8594 0 15.7109 0C24.4005 0 31.4401 6.93529 31.4401 15.496Z",
    fill: "#2187FB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.70784 9.35525C7.93788 9.15658 7.11292 9.6081 6.89293 10.3666C6.67294 11.1252 7.11292 11.9199 7.88288 12.1185L12.6126 13.3647V24.9235C12.6126 25.7182 13.2726 26.3684 14.0792 26.3864C14.8858 26.4045 15.5458 25.7724 15.5458 24.9777V12.2811C15.5458 11.667 15.1425 11.1252 14.5925 10.9085C14.5375 10.8904 14.4642 10.8543 14.4092 10.8362L8.70784 9.35525Z",
    fill: "#0D346D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0837 13.5098V25.1589C19.0837 25.9536 18.4238 26.5857 17.6172 26.5676C16.8105 26.5496 16.1506 25.8813 16.1506 25.1047V12.5345C16.1506 12.4623 16.1506 12.4081 16.1506 12.3358C16.1689 11.7218 16.5906 11.2161 17.1405 11.0535C17.1772 11.0355 17.2138 11.0355 17.2505 11.0174L22.7869 9.5545C23.5568 9.35583 24.3451 9.80734 24.5468 10.584C24.7301 11.3606 24.2535 12.1552 23.4835 12.3539L19.0837 13.5098Z",
    fill: "#0D346D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1013 6.21306C9.33131 6.01439 8.50635 6.46591 8.28637 7.22446C8.06638 7.983 8.50635 8.77767 9.27631 8.97634L15.326 10.5837C15.5826 10.656 15.8393 10.656 16.0776 10.5837C16.1326 10.5837 16.2059 10.5657 16.2609 10.5476L22.3289 9.01246C23.1172 8.81379 23.5572 8.03719 23.3555 7.27864C23.1356 6.52009 22.3289 6.05052 21.5406 6.24918L15.7293 7.71209L10.1013 6.21306Z",
    fill: "#0D346D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDarkSmall);
export default __webpack_public_path__ + "static/media/logo-dark-small.69081dba2f9694acc73e7b8af7e13e6b.svg";
export { ForwardRef as ReactComponent };